/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the AddUserCommentCommandDto interface.
 */
export function instanceOfAddUserCommentCommandDto(value) {
    if (!('userId' in value) || value['userId'] === undefined)
        return false;
    if (!('jobId' in value) || value['jobId'] === undefined)
        return false;
    if (!('body' in value) || value['body'] === undefined)
        return false;
    return true;
}
export function AddUserCommentCommandDtoFromJSON(json) {
    return AddUserCommentCommandDtoFromJSONTyped(json, false);
}
export function AddUserCommentCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'userId': json['userId'],
        'jobId': json['jobId'],
        'body': json['body'],
    };
}
export function AddUserCommentCommandDtoToJSON(json) {
    return AddUserCommentCommandDtoToJSONTyped(json, false);
}
export function AddUserCommentCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'userId': value['userId'],
        'jobId': value['jobId'],
        'body': value['body'],
    };
}
